module.exports = __webpack_public_path__ + "static/Kollektif-Italic-a28604a01636f3a9249559626bc6e5ab.ttf";